import React, { Component } from 'react';
import { Calendar, Menu } from 'antd-mobile';
import { startTime, endTime } from 'common/util';
import moment from "moment";
import "./index.less"

export default class BacklogMenu extends Component {

    state = {
        tabIndex: 1, // 用于待办页切换菜单上面的导航栏
        startDate: null, // 用于选择开始日期
        endDate: null, // 用于选择结束日期
        dateIndex: 0, // 用于切换筛选日期
        carrierListData: [], // 存储承运商pk
        carrierListIndexData: [], // 用于切换承运商存储多选条件的信息
        show: false // 用于展示日历组件
    }

    // 用于存储承运商pk
    carrierListDataTemp = []
    // 用于存储筛选菜单各个状态
    menuStatus = {}

    backlogMenuTabs = [
        { tabName: "日期", num: 1 },
        // { tabName: "承运商", num: 2 }
    ]

    dateChoiceData = [
        { 
            name: "当天", 
            id: 1, 
            startDate:new Date(Date.now()),
            endDate:new Date(Date.now())
        },
        { 
            name: "本周", 
            id: 2,
            startDate: new Date(Date.now() - startTime('week')*24*60*60*1000),
            endDate: new Date(Date.now() + endTime('week')*24*60*60*1000)
        },
        { 
            name: "上月", 
            id: 3,
            startDate: new Date(startTime('lastMonth')),
            endDate: new Date(endTime('lastMonth'))
        },
        { 
            name: "本月", 
            id: 4,
            startDate: new Date(startTime('month')),
            endDate: new Date(endTime('month'))
        }
    ]

    // 切换菜单导航栏
    switchTab = id => {
        this.setState({
            tabIndex: id
        })
    }

    // 切换筛选日期
    switchDate = (id, startDate, endDate) => {
        this.setState({
            dateIndex: id,
            startDate,
            endDate,
        })
    }

    // 切换承运商
    switchCarrier = (data, id) => {
        const { carrierListData, carrierListIndexData } = this.state;
        if(carrierListIndexData.includes(id)){
            carrierListIndexData.forEach((item, index)=>{
                if( id === item ){
                    carrierListIndexData.splice( index , 1);
                    carrierListData.splice( index , 1);
                }
            });
        } else {
            carrierListData.push(data.pk);
            carrierListIndexData.push(id);
        }
        this.setState({
            carrierListData,
            carrierListIndexData
        }, () => {
            this.carrierListDataTemp = [...carrierListData];
        })
    }

    // 重置当前所有的操作
    resetInfo = () => {
        this.setState({
            startDate: null,
            endDate: null,
            dateIndex: 0,
            carrierListIndexData: [],
            carrierListData:[]
        }, () => {
            const { startDate, endDate, carrierListData} = this.state;
            const { getBacklogSubmitStatus } = this.props;
            this.menuStatus = {};
            this.carrierListDataTemp = [...carrierListData];
            getBacklogSubmitStatus( "backlogReset", startDate, endDate, this.carrierListDataTemp );
        })
    }

    // 提交选中的信息
    submitInfo = () => {
        const { startDate, endDate, dateIndex, carrierListIndexData, carrierListData } = this.state;
        this.menuStatus = Object.assign({}, this.menuStatus, {startDate}, {endDate}, {dateIndex}, {carrierListData}, {carrierListIndexData} )

        const { getBacklogSubmitStatus } = this.props;
        getBacklogSubmitStatus( "backlogSubmit", startDate, endDate, this.carrierListDataTemp );
    }

    // 取消之前选中的DatePicker日期
    cancelDateChoice = () => {
        this.setState({
            dateIndex: 0
        })
    }
    
    choiceDate = e => {
        if(e.target.dataset.type === "date"){
            this.setState({
                show:true
            })
        }
    }

    onCancel = ()=>{
        this.setState({
            show:false
        })
    }

    onConfirm = (startDate, endDate)=>{
        this.setState({
            show: false,
            startDate,
            endDate
        })
    }

    handleMenu = () => {
        if(Object.keys(this.menuStatus).length === 0){
            this.setState({
                startDate: null,
                endDate: null,
                dateIndex: 0,
                carrierListData: [],
                carrierListIndexData: []
            },() => {
                this.carrierListDataTemp = [...this.state.carrierListData];
            })
        }else{
            this.setState({
                startDate: this.menuStatus.startDate,
                endDate: this.menuStatus.endDate,
                dateIndex: this.menuStatus.dateIndex,
                carrierListData: [...this.menuStatus.carrierListData],
                carrierListIndexData: [...this.menuStatus.carrierListIndexData]
            },()=>{
                this.carrierListDataTemp = [...this.state.carrierListData];
            })
        }
    }

    componentDidMount(){
        this.props.onRef(this)
    }

    render() {
        const { showView, carrierData } = this.props;
        const { tabIndex, startDate, endDate, dateIndex, carrierListIndexData, show } = this.state;

        let backlog1Menu = tabIndex === 1 ? "block" : "none";
        let backlog2Menu = tabIndex === 2 ? "block" : "none";
        let showMenu = showView ? "block" : "none";

        // 展示菜单导航栏
        let backlogMenuList = this.backlogMenuTabs.map((item, index)=>{
            let menuStyle = item.num === tabIndex ? "menu-tab-container menu-tab-container-active" : "menu-tab-container"
            return  <div key={index} onClick={()=>this.switchTab(item.num)} className={menuStyle} >
                        <div className="menu-tab-title">{item.tabName}</div>
                    </div>
        })

        // 切换日期的按钮
        let dateChoiceList = this.dateChoiceData.map((item, index)=>{
            let dateChoiceStyle = item.id === dateIndex ? "date-switch date-switch-active" : "date-switch"
            return  <button key={index} className={dateChoiceStyle} onClick={()=>this.switchDate(item.id, item.startDate, item.endDate)}>{item.name}</button>       
        })

        //切换承运商
        let carrierList = carrierData?.map((item, index) => {
            let carrierStyle = carrierListIndexData.includes( index+1 ) ? "carrier-switch carrier-switch-active" :"carrier-switch"
            let showRight = carrierListIndexData.includes( index+1 ) ? "visible" : "hidden";
            return  <div key={item.pk} className={carrierStyle} onClick={()=>this.switchCarrier(item, index+1)}>
                        <div className="carrier-name">{item.name}</div>
                        <span className="carrier-choice" style={{visibility:showRight}}></span>
                    </div>
        })

        return (
            <div className = "home-page-menu" style={{display: showMenu}}>
                <div className="menu-tab">{backlogMenuList}</div>
                <div className="menu-container">
                    <div className="container-date" style={{display:backlog1Menu}}>
                        <div className="am-datepicker" onClick={this.choiceDate}>
                            <button data-type="date" className="date-choose-button-left" onClick={this.cancelDateChoice}>
                                {startDate ? moment(new Date(startDate)).format("YYYY-MM-DD") : "开始日期"}
                            </button>
                            <div className="date-link"></div>
                            <button data-type="date" className="date-choose-button-right" onClick={this.cancelDateChoice}>
                                {endDate ? moment(new Date(endDate)).format("YYYY-MM-DD") : "结束日期"}
                            </button>
                        </div>
                        <Calendar
                            visible = {show}
                            onCancel = {this.onCancel}
                            onConfirm = {this.onConfirm}
                            defaultDate = {new Date(startTime('lastMonth'))}
                            defaultValue = {[startDate, endDate]}
                        />
                        <div className="date-choice">{dateChoiceList}</div>
                    </div>
                    <div className="container-carrier" style={{display:backlog2Menu}}>
                        {carrierList}
                    </div>
                </div>
                <div className="menu-button">
                    <button type="reset" className="button-reset" onClick={this.resetInfo}>重置</button>
                    <button type="submit" className="button-right" onClick={this.submitInfo}>确定</button>
                </div>
            </div>
        )
    }
}
